import React from 'react';
import styled from 'styled-components';
import { Drawer as AntdDrawer } from 'antd';
import { DrawerProps as AntdDrawerProps } from 'antd/lib/drawer';
import { LayoutContext } from 'contexts';
import { zPositions } from '@/constants';
import { Title } from '../Typography';
import Icon from '../Icon';

export interface DrawerProps extends AntdDrawerProps {
  type?: 'mobile';
}

const contentPadding = 24;

const StyledFooter = styled.div`
  padding: 20px ${contentPadding}px;
  background: white;
  width: 100%;
  position: relative;
  display: grid;
  grid-row-gap: 2px;
  &:after {
    content: '';
    pointer-events: none;
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: 60px;
    box-shadow: inset 0px -80px 12px -53px white;
  }
  > * {
    width: 100%;
    margin: auto;
    display: block;
  }
`;

export const Drawer: React.FC<DrawerProps> = ({
  type,
  title,
  footer,
  ...props
}) => {
  const { offsetTop } = React.useContext(LayoutContext);

  if (type === 'mobile') {
    return (
      <AntdDrawer
        {...props}
        title={
          typeof title !== 'string' ? (
            title
          ) : (
            <Title level={2} textAlign="center" hideMargin>
              {title}
            </Title>
          )
        }
        zIndex={zPositions.drawer}
        closeIcon={<Icon type="x" />}
        bodyStyle={{
          padding: `0 ${contentPadding}px ${contentPadding}px ${contentPadding}px`,
        }}
        drawerStyle={{
          background: 'white',
          borderRadius: '32px 32px 0 0',
        }}
        headerStyle={{ border: 'none', paddingBottom: 0 }}
        footer={footer && <StyledFooter>{footer}</StyledFooter>}
        footerStyle={{ padding: 0 }}
        placement="bottom"
        height="calc(100vh - 100px)"
      />
    );
  }
  return (
    <AntdDrawer
      style={{ paddingTop: offsetTop || '' }}
      title={title}
      footer={footer}
      zIndex={zPositions.drawer}
      {...props}
    />
  );
};

export default Drawer;
